import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Form, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axios from "axios";
import "./QuestionnaireForm.css";
import { Layout } from "../layout/Layout";

// Import new components
import PersonalInfo from "./questionnaire/PersonalInfo";
import HouseInfo from "./questionnaire/HouseInfo";
import PropertyInfo from "./questionnaire/PropertyInfo";
import BuildingStructure from "./questionnaire/BuildingStructure";
import BuildingStructure2 from "./questionnaire/BuildingStructureRight";
import SanitationInfo from "./questionnaire/SanitationInfo";
import AdditionalInfo from "./questionnaire/AdditionalInfo";
import PhotoUpload from "./questionnaire/PhotoUpload";
import CoordinateInput from "./questionnaire/CoordinateInput";
// Import constants and validation
import { kecamatanDesa, requiredCoordinateKecamatan } from "./questionnaire/constants";
import { validateForm, validateCoordinate } from "./questionnaire/validation";

const QuestionnaireForm = () => {
  const navigate = useNavigate();
  const [isBacklog, setIsBacklog] = useState(false);
  const [fotoRumah, setFotoRumah] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isPreviewing, setIsPreviewing] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 800);
  // State untuk data formulir
  const [formData, setFormData] = useState({
    statusrumah: "",
    nomorUrut: "",
    nomorRumahPadaPeta: "",
    namaLengkapKK: "",
    tanggallahir: "",
    jenisKelamin: "",
    nomorKK: "",
    nomorKTP: "",
    asalKTP: "",
    jumlahKK: "",
    jumlahPenghuni: "",
    alamatRumah: "",
    kecamatan: "",
    desaKelurahan: "",
    pendidikanTerakhir: "",
    pekerjaan: "",
    fungsiBangunan: "",
    penghasilan: "",
    statusKepemilikanRumah: "",
    asetRumahDiTempatLain: "",
    statusKepemilikanTanah: "",
    asetTanahDiTempatLain: "",
    sumberPenerangan: "",
    dayaListrik: "",
    bantuanPerumahan: "",
    modelRumah: "",
    pondasi: "",
    kolom: "",
    rangkaAtap: "",
    plafon: "",
    balok: "",
    sloof: "",
    pintuJendelaKonsen: "",
    ventilasi: "",
    materialLantaiTerluas: "",
    kondisiLantai: "",
    materialDindingTerluas: "",
    kondisiDinding: "",
    materialPenutupAtapTerluas: "",
    kondisiPenutupAtap: "",
    luasRumah: "",
    luasTanah: "",
    buanganAirLimbahRumahTangga: "",
    saranaPengelolaanLimbahCair: "",
    pemiliharaanSaranaPengelolaanLimbah: "",
    jenisTempatPembuanganAirTinja: "",
    kepemilikanKamarMandiDanJamban: "",
    jumlahJamban: "",
    jenisKloset: "",
    jenisTangkiSeptik: "",
    materialTangkiSeptik: "",
    alasTangkiSeptik: "",
    lubangPenyedotan: "",
    posisiTangkiSeptik: "",
    jarakTangkiSeptikDenganSumberAir: "",
    sumberAirMinum: "",
    titikKoordinatRumah: "",
    manualTitikKoordinatRumah: "",
    tanggalPendataan: "",
    namaSurveyor: "",
    kategori: "",
    score: 0,
    catatan:"",
    backlog: [
      {
        namaKK: "",
        nomorKK: "",
        alamat: "",
        pekerjaan: "",
        penghasilan: "",
        jumlahAnggotaKK: "",
        kepemilikanTanah: "",
        usiaPernikahan: ""
      }
    ]
  });

  const [errors, setErrors] = useState({});
  const [desaOptions, setDesaOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  

  useEffect(() => {
    const fetchSurveyorName = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/me`, {
          withCredentials: true, 
        });
  
        if (response.status === 200) {
          setFormData((prevData) => ({
            ...prevData,
            namaSurveyor: response.data.username,
          }));
        } else {
          console.error("Gagal mengambil nama surveyor:", response.statusText);
          navigate("/login");
        }
      } catch (error) {
        console.error("Error mengambil nama surveyor:", error);
        navigate("/login");
      }
    };
  
    fetchSurveyorName();
  }, [navigate]);
  

  // Update opsi desa berdasarkan kecamatan yang dipilih
  useEffect(() => {
    setDesaOptions(kecamatanDesa[formData.kecamatan] || []);
  }, [formData.kecamatan]);

  // Validasi form
  const validateFormData = () => {
    const newErrors = validateForm(formData);
    
    // Set error dan tampilkan
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      const errorMessages = Object.values(newErrors).join("\n");
      window.alert(`Harap perbaiki kesalahan berikut:\n\n${errorMessages}`);
      return false;
    }
  
    return true;
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 800);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: value,
       
        ...(name === "manualTitikKoordinatRumah" ? { titikKoordinatRumah: "" } : {}),
        ...(name === "titikKoordinatRumah" ? { manualTitikKoordinatRumah: "" } : {}),
      };
      if (name === "pondasi" || name === "modelRumah") {
        const nextPondasi = name === "pondasi" ? value : updatedData.pondasi;
        const nextModelRumah = name === "modelRumah" ? value : updatedData.modelRumah;
        const shouldForceTidakLayak = nextPondasi === "Tidak Layak" && nextModelRumah !== "Panggung";
        const forced = [
          "kolom", "rangkaAtap", "plafon", "balok", "sloof",
          "pintuJendelaKonsen", "ventilasi", "materialLantaiTerluas",
          "kondisiLantai", "materialDindingTerluas", "kondisiDinding",
          "materialPenutupAtapTerluas", "kondisiPenutupAtap"
        ];
        forced.forEach((field) => { updatedData[field] = shouldForceTidakLayak ? "Tidak Layak" : ""; });
        updatedData.isManualLantai = false;
        updatedData.isManualDinding = false;
        updatedData.isManualPenutupAtap = false;
      }
  
      console.log("Updated Data Before Conditional Logic:", updatedData);

    if (name === "kepemilikanKamarMandiDanJamban" && value === "Tidak Ada") {
      updatedData = {
        ...updatedData,
        jumlahJamban: 0,
        jenisKloset: "Tidak Ada",
        jenisTangkiSeptik: "Tidak Ada",
        materialTangkiSeptik: "Tidak Ada",
        alasTangkiSeptik: "Tidak Ada",
        lubangPenyedotan: "Tidak Ada",
        posisiTangkiSeptik: "Tidak Ada",
        jarakTangkiSeptikDenganSumberAir: "Tidak Ada",
      };
    }
    if (name === "materialLantaiTerluas" && value === "manual") {
      updatedData.isManualLantai = true;
      updatedData.materialLantaiTerluasManual = "";
    } else if (name === "materialLantaiTerluasManual") {
      updatedData.materialLantaiTerluas = value; 
      updatedData.isManualLantai = true;
    }
    if (name === "materialDindingTerluas" && value === "manual") {
      updatedData.isManualDinding = true;
      updatedData.materialDindingTerluasManual = "";
    } else if (name === "materialDindingTerluasManual") {
      updatedData.materialDindingTerluas = value; 
      updatedData.isManualDinding = true;
    }
    if (name === "materialPenutupAtapTerluas" && value === "manual") {
      updatedData.isManualPenutupAtap = true;
      updatedData.materialPenutupAtapTerluasManual = "";
    } else if (name === "materialPenutupAtapTerluasManual") {
      updatedData.materialPenutupAtapTerluas = value; 
      updatedData.isManualPenutupAtap = true;
    }
    // if (name === "penghasilan" && value === "manual") {
    //   updatedData.penghasilanManual = "";
    // } else if (name === "penghasilanManual") {
    //   updatedData.penghasilanManual = value;
    // }
    // if (name === "penghasilan" && value === "manual") {
    //   newData.penghasilanManual = "";
    // } else if (name === "penghasilanManual") {
    //   newData.penghasilan = "manual"; 
    // }
    if (name === "penghasilan" && value === "manual") {
      updatedData.isPenghasilanManual = true;
      updatedData.penghasilanManual = "";
    } else if (name === "penghasilanManual") {
      updatedData.penghasilan = value; 
      updatedData.isPenghasilanManual = true;
    }
    if (name === "pekerjaan" && value === "manual") {
      updatedData.isPekerjaanManual = true;
      updatedData.pekerjaanManual = "";
    } else if (name === "pekerjaanManual") {
      updatedData.pekerjaan = value; 
      updatedData.isPekerjaanManual = true;
    }
    
    // if (name === "pekerjaan" && value === "manual") {
    //   newData.pekerjaanManual = "";
    // } else if (name === "pekerjaanManual") {
    //   newData.pekerjaan = "manual";
    // }
      if (name === "statusrumah" && value === "Tidak Berpenghuni") {
        updatedData = {
          ...updatedData,
          tanggallahir: null,
          jenisKelamin: "Kosong",
          nomorKK: "0000000000000000",
          nomorKTP: "0000000000000000",
          asalKTP: "0",
          jumlahKK: "0",
          jumlahPenghuni: "0",
          pendidikanTerakhir: "0",
          pekerjaan: "0",
          penghasilan: "0",
          statusKepemilikanRumah: "0",
          asetRumahDiTempatLain: "0",
          statusKepemilikanTanah: "0",
          asetTanahDiTempatLain: "0",
          sumberPenerangan: "0",
          dayaListrik: "0",
          bantuanPerumahan: "0",
         // materialLantaiTerluas: "0",
         // materialPenutupAtapTerluas: "0",
          buanganAirLimbahRumahTangga: "0",
          saranaPengelolaanLimbahCair: "0",
          pemiliharaanSaranaPengelolaanLimbah: "0",
          jenisTempatPembuanganAirTinja: "0",
          kepemilikanKamarMandiDanJamban: "0",
          jumlahJamban: "0",
          jenisKloset: "0",
          jenisTangkiSeptik: "0",
          materialTangkiSeptik: "0",
          alasTangkiSeptik: "0",
          lubangPenyedotan: "0",
          posisiTangkiSeptik: "0",
          jarakTangkiSeptikDenganSumberAir: "0",
          sumberAirMinum: "0",
         
        };
      }
  
      return updatedData;
    });
  
    // Set backlog jika jumlahKK lebih dari 1
    // if (name === "jumlahKK") {
    //   setIsBacklog(parseInt(value) > 1);
    // }
    if (name === "jumlahKK") {
      const jumlahKK = parseInt(value, 10);
      setIsBacklog(jumlahKK > 1);
      
      setFormData((prevData) => {
        const newBacklog = [];
        
        if (jumlahKK > 1) {
          // Buat backlog sebanyak jumlahKK - 1 (karena 1 adalah pemilik rumah)
          const backlogCount = jumlahKK - 1;
          
          // Jika sudah ada backlog, gunakan yang ada dan tambah jika kurang
          const existingBacklog = Array.isArray(prevData.backlog) ? prevData.backlog : [];
          
          for (let i = 0; i < backlogCount; i++) {
            newBacklog.push(existingBacklog[i] || {
              namaKK: "",
              nomorKK: "",
              alamat: "",
              pekerjaan: "",
              penghasilan: "",
              jumlahAnggotaKK: "",
              kepemilikanTanah: "",
              usiaPernikahan: "",
              isPekerjaanManual: false,
            });
          }
        }
        
        return {
          ...prevData,
          jumlahKK: value,
          backlog: newBacklog,
        };
      });
      return;
    }
  
    // Validasi nomor KK dan nomor KTP agar 16 digit
    if (name === "nomorKK" || name === "nomorKTP") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]:
          value.length !== 16
            ? `${name === "nomorKK" ? "Nomor KK" : "Nomor KTP"} harus terdiri dari 16 digit`
            : "",
      }));
    }
  
    if (value === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Jawaban Tidak Boleh Kosong",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }

    // Pastikan "0" dan "Tidak Ada" tidak dianggap kosong
    if (value === "0" || value === "Tidak Ada") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };
  
  
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateFormData()) return;


  // if (requiredCoordinateKecamatan.includes(formData.kecamatan)) {
  //   if (!formData.titikKoordinatRumah && !formData.manualTitikKoordinatRumah) {
  //     setErrorMessage("Untuk Kecamatan Maluk dan Jereweh, salah satu koordinat harus diisi.");
  //     setModalOpen(true);
  //     return;
  //   }
  if (requiredCoordinateKecamatan.includes(formData.kecamatan)) {
    if (!formData.titikKoordinatRumah) {
      setErrorMessage("Untuk Kecamatan Maluk dan Jereweh, koordinat harus diambil otomatis.");
      setModalOpen(true);
      return;
    }

    if (formData.titikKoordinatRumah && !validateCoordinate(formData.titikKoordinatRumah)) {
      setErrorMessage("Format Titik Koordinat Rumah tidak valid. Gunakan format latitude,longitude.");
      setModalOpen(true);
      return;
    }

    if (formData.manualTitikKoordinatRumah) {
      setErrorMessage("Untuk Kecamatan Maluk dan Jereweh, koordinat manual tidak diperbolehkan.");
      setModalOpen(true);
      return;
    }

    if (!validateCoordinate(formData.titikKoordinatRumah)) {
      setErrorMessage("Format Titik Koordinat Rumah tidak valid. Gunakan format latitude,longitude.");
      setModalOpen(true);
      return;
    }
    if (!imagePreview) {
      setErrorMessage("Untuk Kecamatan Maluk dan Jereweh, Anda harus ambil foto rumah.");
      setModalOpen(true);
      return;
    }
  }

  try {
    const BASE_URL = process.env.REACT_APP_URL;
    
    // **1. Kirim data kuesioner ke backend**
    const { kategori, score, backlog, ...dataToSendBase } = formData;
    const dataToSend = { ...dataToSendBase };
    const response = await axios.post(`${BASE_URL}/createquestionnaires`, dataToSend, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
    console.log("Response from /createquestionnaires:", response);

    if (response.status === 201) {
      const questionnaireId = response.data.questionnaire.id; 
      if (fotoRumah) {
        const fotoFormData = new FormData();
        fotoFormData.append("questionnaireId", questionnaireId);
        fotoFormData.append("foto", fotoRumah);

        await axios.post(`${BASE_URL}/uploadfoto`, fotoFormData, {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        });
      }

      // **3. Kirim data backlog jika ada**
      if (parseInt(formData.jumlahKK, 10) > 1 && Array.isArray(formData.backlog) && formData.backlog.length > 0) {
        console.log("Sending backlog data:", formData.backlog);
        
        // Kirim setiap backlog record
        for (const backlogItem of formData.backlog) {
          if (backlogItem.namaKK && backlogItem.nomorKK && backlogItem.alamat && 
              backlogItem.pekerjaan && backlogItem.penghasilan && backlogItem.jumlahAnggotaKK && 
              backlogItem.kepemilikanTanah && backlogItem.usiaPernikahan) {
            
            const backlogData = {
              questionnaireId: questionnaireId,
              namaKK: backlogItem.namaKK,
              nomorKK: backlogItem.nomorKK,
              alamat: backlogItem.alamat,
              pekerjaan: backlogItem.pekerjaan,
              penghasilan: backlogItem.penghasilan,
              jumlahAnggotaKK: backlogItem.jumlahAnggotaKK,
              kepemilikanTanah: backlogItem.kepemilikanTanah,
              usiaPernikahan: backlogItem.usiaPernikahan
            };
            
            await axios.post(`${BASE_URL}/backlog`, backlogData, {
              headers: {
                "Content-Type": "application/json",
              },
              withCredentials: true,
            });
            
            console.log("Backlog record created:", backlogData);
          }
        }
      }

      setSuccessMessage("Data dan foto berhasil disimpan!");
      setModalOpen(true);
      setFormData({
        statusrumah: "",
        nomorUrut: "",
        nomorRumahPadaPeta: "",
        namaLengkapKK: "",
        tanggallahir: "",
        jenisKelamin: "",
        nomorKK: "",
        nomorKTP: "",
        asalKTP: "",
        jumlahKK: "",
        jumlahPenghuni: "",
        alamatRumah: "",
        kecamatan: "",
        desaKelurahan: "",
        pendidikanTerakhir: "",
        pekerjaan: "",
        fungsiBangunan: "",
        penghasilan: "",
        statusKepemilikanRumah: "",
        asetRumahDiTempatLain: "",
        statusKepemilikanTanah: "",
        asetTanahDiTempatLain: "",
        sumberPenerangan: "",
        dayaListrik: "",
        bantuanPerumahan: "",
        modelRumah: "",
        pondasi: "",
        kolom: "",
        rangkaAtap: "",
        plafon: "",
        balok: "",
        sloof: "",
        pintuJendelaKonsen: "",
        ventilasi: "",
        materialLantaiTerluas: "",
        kondisiLantai: "",
        materialDindingTerluas: "",
        kondisiDinding: "",
        materialPenutupAtapTerluas: "",
        kondisiPenutupAtap: "",
        luasRumah: "",
        luasTanah: "",
        buanganAirLimbahRumahTangga: "",
        saranaPengelolaanLimbahCair: "",
        pemiliharaanSaranaPengelolaanLimbah: "",
        jenisTempatPembuanganAirTinja: "",
        kepemilikanKamarMandiDanJamban: "",
        jumlahJamban: "",
        jenisKloset: "",
        jenisTangkiSeptik: "",
        materialTangkiSeptik: "",
        alasTangkiSeptik: "",
        lubangPenyedotan: "",
        posisiTangkiSeptik: "",
        jarakTangkiSeptikDenganSumberAir: "",
        sumberAirMinum: "",
        titikKoordinatRumah: "",
        manualTitikKoordinatRumah: "",
        tanggalPendataan: "",
        namaSurveyor: formData.namaSurveyor,
        kategori: "",
        score: 0,
        catatan: "",
        backlog: [],
      });

      setErrorMessage("");
    } else {
      setErrorMessage("Gagal mengirim data. Silakan coba lagi.");
      setModalOpen(true);
    }
  } catch (error) {
    setErrorMessage(error.response?.data?.message || "Gagal menyimpan data.");
    setSuccessMessage("");
    setModalOpen(true);
  }
};


  // // Toggle modal
  // const toggleModal = () => setModalOpen(!modalOpen);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (successMessage) {
      navigate('/recap'); 
    }
  };
  // Get coordinates using Geolocation API
  const handleGetCoordinates = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setFormData((prevData) => ({
            ...prevData,
            titikKoordinatRumah: `${latitude}, ${longitude}`,
            manualTitikKoordinatRumah: "", 
          }));
        },
        (error) => {
          setErrorMessage("Error getting coordinates: " + error.message);
          setModalOpen(true); 
        }
      );
    } else {
      setErrorMessage("Geolocation is not supported by this browser.");
      setModalOpen(true); 
    }
  };

  return (
    <Layout>
    <Row
      className={`justify-content-center ${isMobile ? "mx-0" : ""}`}
      style={{ marginLeft: isMobile ? "0" : "280px" }}
    >
       
       
          <Form onSubmit={handleSubmit}sx={{ p: 3, maxWidth: "800px", marginLeft: { xs: 0, md: "280px" } }}>
            <h3>Formulir Pendataan:</h3>
            <div className="home-logo-container">
              <img src="/images/logobaru.svg" alt="Logo Aplikasi" className="home-logo"/>
            </div>
            <div className="form-container">
  <div className="form-column">
    {/* Bagian kiri form */}
    <PersonalInfo 
      formData={formData} 
      handleChange={handleChange} 
      errors={errors} 
    />
    
    <HouseInfo 
      formData={formData} 
      handleChange={handleChange} 
      errors={errors} 
      isBacklog={isBacklog}
      desaOptions={desaOptions}
    />



            {/* <FormGroup>
              <Label for="jumlahKK">9. Jumlah KK Dalam Rumah</Label>
              <Input type="number" name="jumlahKK" id="jumlahKK" value={formData.jumlahKK || ""} onChange={handleChange} 
               disabled={formData.statusrumah === "Tidak Berpenghuni"}
              className="input-center" />
              {errors.jumlahKK && <div className="invalid-feedback">{errors.jumlahKK}</div>}
            </FormGroup> */}
  <PropertyInfo 
      formData={formData} 
      handleChange={handleChange} 
      errors={errors} 
    />
     <BuildingStructure 
      formData={formData} 
      handleChange={handleChange} 
      errors={errors} 
    />
    {/* Tambahkan lebih banyak FormGroup di sini */}
  </div>
  <div className="form-column">
    {/* Bagian kanan form */}
  
    <BuildingStructure2
        formData={formData} 
        handleChange={handleChange} 
        errors={errors}  />
   
    
    <SanitationInfo 
      formData={formData} 
      handleChange={handleChange} 
      errors={errors} 
    />
    
    <CoordinateInput 
      formData={formData} 
      handleChange={handleChange} 
      handleGetCoordinates={handleGetCoordinates}
      errors={errors} 
      requiredCoordinateKecamatan={requiredCoordinateKecamatan}
    />
    
    <AdditionalInfo 
      formData={formData} 
      handleChange={handleChange} 
      errors={errors} 
    />
    
    <PhotoUpload 
      fotoRumah={fotoRumah}
      setFotoRumah={setFotoRumah}
      imagePreview={imagePreview}
      setImagePreview={setImagePreview}
      isPreviewing={isPreviewing}
      setIsPreviewing={setIsPreviewing}
    />

    {/* Submit buttons */}
    <div className="mt-3 d-grid gap-2 d-md-flex justify-content-md-start">
      <Button className="btn-primary" type="submit">
        Simpan
      </Button>

      <Button className="btn-secondary" type="button" onClick={() => navigate("/recap")}>
        Lihat Rekap
      </Button>
    </div>
  </div>
</div>

          </Form>
       
      </Row>

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{errorMessage ? "Error" : "Sukses"}</ModalHeader>
        <ModalBody>{errorMessage || successMessage}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
  
    {/* <Footer /> */}
 </Layout>  
  );
};

export default QuestionnaireForm;
